import { DryerGroup } from './dryer-group.dto';

export interface ModelDTO {
  calculatedId?: number;
  pressureDrop?: string;
  exactModel?: ProductEntity;
  airFlowMargin?: number;
  outletAirFlow?: number;
  purgeFlow?: number;
  matchPercentage?: number;
  limitSuccess?: boolean;
}

export interface ProductEntity {
  id?: any;
  model: string;
  maxFlow: number;
  netWeight: number;
  height: number;
  depth: number;
  width: number;
  airConnection: string;
  coolingMedia: string;
  nominalConsumption: string;
  nominalCurrent: string;
  fullLoadCurrent: string;
  lockedRotorCurrent: string;
  dryerType: DryerType;
  dryerCategory: DryerCategory;
  dryerGroup: DryerGroup;
  sensors: SensorEntity[];
}

export enum DryerType {
  AIR_COOLED = 'Air Cooled',
  WATER_COOLED = 'Water Cooled',
  HEATLESS = 'Heatless',
  HEATED = 'Heated',
}

export enum DryerCategory {
  CYCLING_REFRIGERATED = 'Cycling Refrigerated',
  NON_CYCLING_REFRIGERATED = 'Non-Cycling Refrigerated',
  SUBFREEZING = 'Subfreezing',
  HIGH_TEMPERATURE_REFRIGERATED = 'High Temperature Refrigerated',
  DESICCANT = 'Desiccant',
  DESICCANT_MODULAR = 'Desiccant Modular',
  TWIN_TOWER = 'Twin Tower',
  VSD = 'VSD',
}
export interface SensorEntity {
  sensorId: string;
  name: string;
  thresholdMin: number | null;
  thresholdMax: number | string | null;
  value: string | number | null;
  unit: string | null;
}

export interface SuggestedModel {
  matchPercentage: number;
  pressureDrop: number;
  model: ProductEntity;
  warningMessage?: string;
  isHeaterRequired?: boolean;
  selected?: boolean;
  expanded?: boolean;
}

export interface SelectedRow {
  id?: any;
  model?: string;
  maxFlow?: number;
  calculatedId: number;
  exactModel: ProductEntity;
  pressureDrop: string;
  percentage: number;
  purgeFlow: number;
  outletAirFlow: number;
  suggestedModels: {
    closestModel: SuggestedModel[];
  };
  selected?: boolean;
  expanded?: true;
  airFlowMargin?: number;
  warningMessage?: string;
  isHeaterRequired?: boolean;
  limitSuccess?: boolean;
  isRecommended?: boolean;
  isBelowThreshold?: boolean;
  categoryGroupId?: number;
}
